import React , { useEffect , useState } from 'react';
import AnimateButton from '../../../common/Button/AnimateButton';
import EditProductModalWrapper from '../../../common/Modals/EditProductModalWrapper';
import FileUploadProgress from './FileUploadProgress';
import NoFilesUploaded from './NoFilesUploaded';
import UploadedFiles from './UploadedFiles';
import './scss/view-uploaded-files-slider.scss';
import ViewFileDetailsSlider from './ViewFileDetailsSlider';
import BrochureUploadModal from '../../listing/BrochureUploadModal';
import { useSelector } from 'react-redux';

const UploadFilesView = props => {
    const {
        fromAttachment,
        hideAddButton,
        validateInput,
        saveDisplayName,
        imagePreviewRef,
        fromFileModule = false
    } = props;
    const isServiceProfile = useSelector(state => state.session?.newProfile == 3);
    const [uploadHistorySlider , toggleHistorySlider] = useState(false);
    const [brochureModalData, setBrochureModalData] = useState(null);

    let MessageAry = ["Supported formats are JPG, JPEG, PNG, WEBP and PDF Documents. Please <span class='info-msg-bold'>DO NOT</span> upload your business premise photos as they will get rejected."]
    
    if (props.isContractor) {
        MessageAry.push('Please note that the uploaded file will be audited within 3 working days before it goes live.')
    }else if(fromFileModule) {
        MessageAry = ["Supported size for each file is 5 MB and total size is 100 MB"]
    }

    useEffect(() => {
        console.log('historyslider', uploadHistorySlider);
    },[uploadHistorySlider])

    const toggleHistory = () => {
        toggleHistorySlider(true);
    }

    const handleBrochureFileChange = async (e) => {
        const { target : { files } } = e;
        const { brochureFileHandling  } = await import('../../listing/brochurelisting.utils');
        try {
            const uploadedFiles = await brochureFileHandling(files);
            if (!isServiceProfile && uploadedFiles && uploadedFiles.length > 0) {
                setBrochureModalData(uploadedFiles);
            }
        } catch(err){
            console.error(err);
        }
    }
    
    return (
        <div className={fromAttachment ? '' : 'view-uploaded-files-slider'}>
            <div className={'view-files-slider-main'}>
                            
            {!props.fileAttachmentArr.length || (props.progressProps.allDeleted) || (!props.progressProps.uploadedCount && !props.progressProps.previouslyUploadedCount && props.fromAttachment) ?
                <>   
                {!props.uploadedCount ?
                    <FileUploadProgress 
                        productId = {props.productId}
                        progressProps={props.progressProps}
                        fromAttachment={fromAttachment}
                        isBrochure={props.isBrochure}
                        toggleFileSlider={toggleHistory}
                        fromFileModule={fromFileModule}
                    />
                    : null }
                    {fromFileModule ? 
                        <div className='no-attach-holder'>
                            <props.NoAttachment /> 
                        </div> :
                    <NoFilesUploaded onClick={props.uploadFiles}
                        message={props.isBrochure && MessageAry}
                        isRenderHtml={true}
                        onFileChange={props.isBrochure && handleBrochureFileChange}
                        fromFileModule={fromFileModule}
                        isReadOnly={props.isReadOnly}
                        isBrochure={props.isBrochure}
                    />}
                </>
                :
                <>
                    <FileUploadProgress 
                        productId = {props.productId}
                        progressProps={props.progressProps}
                        toggleFileSlider={toggleHistory}
                        fromAttachment={fromAttachment}
                        fileAttachmentArr={props.fileAttachmentArr}
                        isBrochure={props.isBrochure}
                        fromFileModule={fromFileModule}
                    />
                    {!props.progressProps.uploadedCount && !props.progressProps.previouslyUploadedCount && (props.fromAttachment ? true : !props.fileAttachmentArr.length) ? 
                        fromFileModule ?
                         <div className='no-attach-holder'>
                            <props.NoAttachment /> 
                        </div> : 
                        <NoFilesUploaded onClick={props.uploadFiles}
                        message={props.isBrochure && MessageAry}
                        isRenderHtml={true}
                        onFileChange={props.isBrochure && handleBrochureFileChange}
                        fromFileModule={fromFileModule}
                        isReadOnly={props.isReadOnly}
                        isBrochure={props.isBrochure}
                    /> 
                    :
                    <>
                        <UploadedFiles 
                            productId = {props.productId}
                            progressProps={props.progressProps}
                            isReadOnly={props.isReadOnly}
                            isJdVendor = {props.isJdVendor}
                            fromAttachment={fromAttachment}
                            imagePreviewRef={imagePreviewRef}
                            isBrochure={props.children}
                            isContractor={props.isContractor}
                            uploadBtns={props.uploadBtns}
                            fromFileModule={fromFileModule}
                            deleteCb={props.deleteCb}
                        />
                        {props.children ? props.children : null}
                    </>
                    }
                </>
                }
                </div>
                {uploadHistorySlider ? 
                    <ViewFileDetailsSlider 
                        closeSlider={() => {
                            toggleHistorySlider(false);
                        }}
                        fileAttachmentArr={props.isBrochure ? props.brochureFileHistory : props.fileAttachmentArr}
                        isBrochure={props.isBrochure}
                    />
                    : null}   
                {props.uploadedFileModalData.show ? <EditProductModalWrapper
                inputObj={props.uploadedFileModalData.inputObj.inputFields}
                {...props.uploadedFileModalData.inputObj.modalData}
                customValidation = {true}
                validateModalData = {validateInput}
                onAddEditModalBtnClick={saveDisplayName}
                onModalClose={() => { props.toggleEditDisplayNameModal({ show: false }) }}
            /> : null}    
            {(hideAddButton || props.isReadOnly)  ? null : <AnimateButton
                btnText='Attach Files'
                iconClass="icon-plus"
                className={'attach-btn'}
                onClick={props.uploadFiles}
                btnWidth='9.125rem'
            />}
            {props.footerBtn ?
                props.footerBtn()
            : null}
            {brochureModalData ?
                <BrochureUploadModal
                    uploadedFiles={brochureModalData}
                    onHidden={() => setBrochureModalData(null)}
                />
            : null}
        </div>
    );
};

export default UploadFilesView;